<template>
  <div id="contact" class="contact-wrap style4 ptb-100">
    <div class="container">
      <div class="row">
        <div class="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2">
          <div class="section-title style1 text-center mb-40">
            <span>Keep In Touch With Us</span>
            <h2>Contact Information</h2>
          </div>
        </div>
      </div>

      <div class="row gx-5 align-items-center">
        <div class="col-lg-6">
          <div class="contact-bg-one bg-f"></div>
        </div>

        <div class="col-lg-6">
          <form class="form-wrap" id="contactForm">
            <h5>Fell Free To Contact Us For Any Query</h5>
            <div class="row">
              <div class="col-lg-12">
                <div class="form-group">
                  <input
                    type="text"
                    name="name"
                    placeholder="Full Name*"
                    id="name"
                    required
                  />
                </div>
              </div>

              <div class="col-lg-12">
                <div class="form-group">
                  <input
                    type="email"
                    name="email"
                    id="email"
                    required
                    placeholder="Email*"
                  />
                </div>
              </div>

              <div class="col-lg-12">
                <div class="form-group">
                  <input
                    type="text"
                    name="phone_number"
                    placeholder="Phone*"
                    id="phone_number"
                    required
                  />
                </div>
              </div>

              <div class="col-lg-12">
                <div class="form-group">
                  <input
                    type="text"
                    name="msg_subject"
                    placeholder="Subject*"
                    id="msg_subject"
                    required
                  />
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group v1">
                  <textarea
                    name="message"
                    id="message"
                    placeholder="Your Messages.."
                    cols="30"
                    rows="10"
                    required
                  ></textarea>
                </div>
              </div>

              <div class="col-12">
                <div class="form-group">
                  <div class="form-check checkbox">
                    <input
                      name="gridCheck"
                      value="I agree to the terms and privacy policy."
                      class="form-check-input"
                      type="checkbox"
                      id="gridCheck"
                      required
                    />
                    <label class="form-check-label" for="gridCheck">
                      I agree to the
                      <router-link class="link style1" to="/terms-of-service">
                        terms &amp; conditions
                      </router-link>
                      and
                      <router-link class="link style1" to="/privacy-policy">
                        privacy policy
                      </router-link>
                    </label>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <button type="submit" class="btn style2">Send Message</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "KeepInTouch",
};
</script>